export default function PrizeRow({
  label,
  shortLabel,
  cells,
  size,
  liveDrawing = false,
  expectedCount = 0,
}) {
  return (
    <tr className={`xoso-prize-row xoso-prize-row--${size}`}>
      <td className="xoso-prize-label">
        <span className="xoso-prize-label-desktop">{label}</span>
        <span className="xoso-prize-label-mobile">{shortLabel}</span>
      </td>
      {cells.map((numbers, idx) => {
        const nums = Array.isArray(numbers) ? numbers : [];
        const spinning = liveDrawing && nums.length < (expectedCount || 1);
        return (
          <td key={idx} className="xoso-prize-value">
            {nums.map((num, i) => (
              <span key={`${num}-${i}`} className="xoso-prize-num">
                {num}
              </span>
            ))}
            {spinning ? <span className="xoso-prize-spin" aria-hidden /> : null}
            {!nums.length && !spinning ? <span className="xoso-prize-num">-</span> : null}
          </td>
        );
      })}
    </tr>
  );
}
